import React from "react";
import { withScriptjs, withGoogleMap } from "react-google-maps";
import Map from "./wrappedMap";
import './maps.css';

const DirectionMap = (props) => {
    const WrappedMap = withScriptjs(withGoogleMap(Map));
    const formattedOrigin = {lat: props.from.lat, lng: props.from.lng}
    const formattedDestination = {lat: props.to.lat, lng: props.to.lng}
    return (
        <main className="home">
            <section className="map">
                {
                    props.apiKey && <WrappedMap
                        googleMapURL={`https://maps.googleapis.com/maps/api/js?libraries=geometry,drawing,places&key=${props.apiKey}&v=3.40`}
                        loadingElement={<div style={{ height: `100%` }} />}
                        containerElement={<div style={{ height: "60vh" }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                        formattedOrigin={formattedOrigin}
                        formattedDestination={formattedDestination}
                        updateDistanceData={props.updateDistanceData}
                    />
                }
            </section>
        </main>
    );
};
export default DirectionMap;
